import { useMemo, useEffect } from 'react';
import { EDSModal } from '@gehc-eds-react/eds-modal';
import { EDSDataGrid } from '@gehc-eds-react/eds-datagrid';
import UploadSummary from '../../constants/UploadSummary';
import { UPLOAD_SUMMARY_TITLE, UPLOAD_SUMMARY_DISCLAIMER } from '../../constants/uploadConfig';
// Renders an UploadSummary inside an EDS modal using a DataGrid.
const UploadSummaryModal = ({
    summary,
    onClose,
    title = UPLOAD_SUMMARY_TITLE,
    disclaimerText = UPLOAD_SUMMARY_DISCLAIMER
}) => {

    // Create model instance from summary data
    const summaryModel = useMemo(() => {
        if (!summary) return null;
        return new UploadSummary(summary);
    }, [summary]);

    // Build dynamic grid rows from model
    const summaryGridRows = useMemo(() => {
        return summaryModel ? summaryModel.toGridRows() : [];
    }, [summaryModel]);

    // Static column config — never changes
    const summaryGridColumns = useMemo(() => {
        return UploadSummary.getColumnConfig();
    }, []);

    // Listen for EDS modal close event (X icon click)
    useEffect(() => {
        const handleModalClose = () => {
            if (summary && onClose) {
                onClose();
            }
        };
        window.addEventListener('eds-modal-close', handleModalClose);
        return () => window.removeEventListener('eds-modal-close', handleModalClose);
    }, [summary, onClose]);

    // Render nothing when no summary
    if (!summary) return null;

    return (
        <EDSModal
            variant={"standard"}
            isOpen={true}
            headerConfig={{
                "text": title,
                "useCancelIcon": true
            }}
            footerConfig={{
                "acceptButton": {
                    "label": "Close",
                    "type": "button"
                }
            }}
            width={"500px"}
            onEDSModalButtonClickAccept={onClose}
            onEDSModalClose={onClose}
            content={
                <div slot="main-content">
                    <div>
                        <EDSDataGrid
                            activeRowId={0}
                            columnConfig={summaryGridColumns}
                            columnFreezing={""}
                            disabledRowCells={{}}
                            gridFeatures={["table-flex-horizontal"]}
                            isLoading={false}
                            labels={{
                                "rowText": "rows of",
                                "noRowsFoundText": "No summary data"
                            }}
                            loadedRowIds={[]}
                            rowFormat={{ "size": "compact", "style": "divider" }}
                            rows={summaryGridRows}
                            visibleRowCount={summaryGridRows.length}
                            totalRowCount={summaryGridRows.length}
                            sortType={""}
                            sort={[]}
                            utilityButtonVariant={"tertiary"}
                        />
                    </div>
                    {summaryModel?.isAborted() && (
                        <div style={{
                            display: 'flex',
                            alignItems: 'flex-start',
                            gap: '6px',
                            padding: '12px 16px',
                            marginTop: '8px',
                            fontSize: '12px',
                            color: '#666',
                            fontStyle: 'italic'
                        }}>
                            <span style={{ fontSize: '14px', flexShrink: 0 }}>⚠️</span>
                            <span>{disclaimerText}</span>
                        </div>
                    )}
                </div>
            }
        />
    );
};

export default UploadSummaryModal;